import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import FolderIcon from "@mui/icons-material/Folder";
import BusinessIcon from "@mui/icons-material/Business";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CategoryIcon from "@mui/icons-material/Category";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import TableChartIcon from "@mui/icons-material/TableChart";
import ListAltIcon from "@mui/icons-material/ListAlt";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const menuConfig = [
  {
    title: "Dashboard",
    path: "/",
    icon: <DashboardIcon />,
  },

  {
    title: "Import",
    path: "/import",
    icon: <SettingsIcon />,
    permission: "A",
  },

  {
    title: "Master Entry",
    icon: <FolderIcon />,
    permission: ["B", "C"],
    children: [
      {
        title: "Consignee",
        path: "/masterentry/consignee",
        icon: <BusinessIcon />,
        permission: "C",
      },
      {
        title: "Allocation",
        path: "/masterentry/allocation",
        icon: <CategoryIcon />,
        permission: "B",
      },
      {
        title: "Allocation Head",
        path: "/masterentry/allocationhead",
        icon: <AccountTreeIcon />,
        permission: "B",
      },
    ],
  },

  {
    title: "Entry",
    icon: <FolderIcon />,
    permission: ["E", "F", "G", "H", "I", "J", "K", "L", "M"],
    children: [
      {
        title: "Time Office Data Entry",
        path: "/entry/timeofficedata",
        icon: <BusinessIcon />,
        permission: "E",
      },
      {
        title: "EGA/ENGA Data",
        path: "/entry/egaenga",
        icon: <CategoryIcon />,
        permission: "F",
      },
      {
        title: "Insentive Data (Zero Shop)",
        path: "/entry/insentive",
        icon: <AccountTreeIcon />,
        permission: "G",
      },
      {
        title: "IOH Data",
        path: "/entry/ioh",
        icon: <CheckCircleIcon />,
        permission: "H",
      },
      {
        title: "POH Data",
        path: "/entry/poh",
        icon: <CheckCircleIcon />,
        permission: "H",
      },
      {
        title: "WLS Data",
        path: "/entry/wls",
        icon: <CheckCircleIcon />,
        permission: "I",
      },
      {
        title: "Store & Proforma on Cost Rate",
        path: "/entry/proforma",
        icon: <CheckCircleIcon />,
        permission: "J",
      },
      {
        title: "Credit JV Data",
        path: "/entry/creditjv",
        icon: <CheckCircleIcon />,
        permission: "K",
      },
      {
        title: "POH Out-Turn",
        path: "/entry/pohoutturn",
        icon: <CheckCircleIcon />,
        permission: "L",
      },
      {
        title: "Update Labour Rate",
        path: "/entry/updatelabourrate",
        icon: <CheckCircleIcon />,
        permission: "M",
      },
    ],
  },

  {
    title: "Admin Process",
    icon: <FolderIcon />,
    permission: ["D", "N"],
    children: [
      {
        title: "Process Monthly Data",
        path: "/masterentry/monthly-data",
        icon: <CheckCircleIcon />,
        permission: "N",
      },
      {
        title: "Finalised Data",
        path: "/masterentry/finalised-data",
        icon: <CheckCircleIcon />,
        permission: "D",
      },
    ],
  },

  {
    title: "Reports",
    icon: <DescriptionIcon />,
    permission: ["O"],
    children: [
      {
        title: "Consignee List",
        path: "/reports/consigneelist",
        icon: <PeopleIcon />,
      },
      {
        title: "Rate List",
        path: "/reports/ratelist",
        icon: <PriceCheckIcon />,
      },
      {
        title: "Allocation List",
        path: "/reports/allocationlist",
        icon: <PeopleIcon />,
      },
      {
        title: "Monthly Reports",
        path: "/reports/monthly",
        icon: <ListAltIcon />,
      },
      {
        title: "Quarterly Reports",
        path: "/reports/quarterly",
        icon: <TableChartIcon />,
      },
    ],
  },

  {
    title: "Settings",
    icon: <SettingsIcon />,
    permission: ["P", "Q", "R", "X"],
    children: [
      {
        title: "User Management",
        path: "/setting/usermanagement",
        icon: <PeopleIcon />,
        permission: "Q",
      },
     
      // {
      //   title: "Data Search",
      //   path: "/setting/search",
      //   icon: <CategoryIcon />,
      //   permission: "P",
      // },
      // {
      //   title: "Query",
      //   path: "/setting/query",
      //   icon: <CategoryIcon />,
      //   permission: "X",
      // },
     
    ],
  },

   // 👇 PROFILE - AVAILABLE TO EVERY LOGGED-IN USER
      // {
      //   title: "My Profile",
      //   path: "/profile",
      //   icon: <AccountCircleIcon />,
      // },
];

export default menuConfig;
